export var ASSIGNMENT_CACHED_REPOSITORY = 'ASSIGNMENT_CACHED_REPOSITORY';